import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import NavBar from './NavBar';
import Footer from './Footer';
import './Contacto.css';

// ─────────────────────────────────────────────────────────
// Configuración EmailJS
// Creá una cuenta en https://www.emailjs.com y completá:
//   REACT_APP_EMAILJS_SERVICE_ID  → ID del servicio Gmail
//   REACT_APP_EMAILJS_TEMPLATE_ID → ID del template
//   REACT_APP_EMAILJS_PUBLIC_KEY  → Public Key de tu cuenta
// ─────────────────────────────────────────────────────────
const SERVICE_ID  = process.env.REACT_APP_EMAILJS_SERVICE_ID  || '';
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || '';
const PUBLIC_KEY  = process.env.REACT_APP_EMAILJS_PUBLIC_KEY  || '';

const IllustrationContact = () => (
  <svg viewBox="0 0 420 360" fill="none" xmlns="http://www.w3.org/2000/svg" className="ct-illustration">
    <circle cx="210" cy="180" r="140" fill="#e4eeea"/>
    <circle cx="80"  cy="70"  r="5"  fill="#c8dbd2"/>
    <circle cx="370" cy="90"  r="4"  fill="#c8dbd2"/>
    <circle cx="390" cy="250" r="6"  fill="#c8dbd2"/>
    <circle cx="55"  cy="270" r="4"  fill="#c8dbd2"/>
    {/* Envelope */}
    <rect x="100" y="120" width="220" height="150" rx="12" fill="#fff" stroke="#c8d8d0" strokeWidth="2"/>
    <path d="M100 132 L210 205 L320 132" stroke="#3a7a58" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <line x1="100" y1="270" x2="168" y2="205" stroke="#c8d8d0" strokeWidth="2" strokeLinecap="round"/>
    <line x1="320" y1="270" x2="252" y2="205" stroke="#c8d8d0" strokeWidth="2" strokeLinecap="round"/>
    {/* Floating card - check */}
    <rect x="290" y="80" width="100" height="55" rx="9" fill="#fff" stroke="#dde8e3" strokeWidth="1.5"/>
    <circle cx="312" cy="107" r="10" fill="#e4eeea"/>
    <polyline points="307,107 311,112 318,101" stroke="#3a7a58" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <rect x="328" y="100" width="48" height="6" rx="3" fill="#c8dbd2"/>
    <rect x="328" y="112" width="36" height="5" rx="2" fill="#dde8e3"/>
    {/* Floating card - mail */}
    <rect x="28" y="180" width="100" height="55" rx="9" fill="#fff" stroke="#dde8e3" strokeWidth="1.5"/>
    <rect x="44" y="196" width="68" height="44" rx="5" fill="#e4eeea"/>
    <path d="M44 201 L78 220 L112 201" stroke="#3a7a58" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    {/* Dots */}
    <circle cx="210" cy="80"  r="3" fill="#b8ccc4"/>
    <circle cx="222" cy="80"  r="3" fill="#b8ccc4"/>
    <circle cx="198" cy="80"  r="3" fill="#b8ccc4"/>
  </svg>
);

function Contacto() {
  const [fields, setFields] = useState({ from_email: '', message: '' });
  const [status, setStatus] = useState('idle'); // idle | sending | success | error
  const [errorDetail, setErrorDetail] = useState('');

  const handleChange = (e) => {
    setFields(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!SERVICE_ID || !TEMPLATE_ID || !PUBLIC_KEY) {
      setStatus('config-error');
      return;
    }
    setStatus('sending');
    setErrorDetail('');
    try {
      await emailjs.send(
        SERVICE_ID,
        TEMPLATE_ID,
        {
          from_email: fields.from_email,
          message:    fields.message,
          to_email:   'branchdevelopment.ar@gmail.com',
          reply_to:   fields.from_email,
        },
        PUBLIC_KEY
      );
      setStatus('success');
      setFields({ from_email: '', message: '' });
    } catch (err) {
      setErrorDetail(err?.text || err?.message || JSON.stringify(err));
      setStatus('error');
    }
  };

  return (
    <div className="Contacto">
      <NavBar />

      <section className="ct-hero">
        <div className="ct-hero-content">
          <span className="ab-badge">Estamos para ayudarte</span>
          <h1 className="ab-title">Contáctanos</h1>
          <p className="ab-lead">
            Contanos tu idea, consulta o proyecto. Te respondemos a la brevedad
            en <strong>branchdevelopment.ar@gmail.com</strong>
          </p>

          <form className="ct-form" onSubmit={handleSubmit} noValidate>
            <div className="ct-field">
              <label htmlFor="from_email">Tu correo electrónico</label>
              <input
                id="from_email"
                type="email"
                name="from_email"
                value={fields.from_email}
                onChange={handleChange}
                placeholder="correo@ejemplo.com"
                required
                autoComplete="email"
              />
            </div>

            <div className="ct-field">
              <label htmlFor="message">Tu consulta</label>
              <textarea
                id="message"
                name="message"
                value={fields.message}
                onChange={handleChange}
                placeholder="Escribí tu consulta o proyecto acá..."
                rows={5}
                required
              />
            </div>

            <button
              type="submit"
              className="ct-submit"
              disabled={status === 'sending'}
            >
              {status === 'sending' ? 'Enviando…' : 'Enviar consulta'}
            </button>

            {status === 'success' && (
              <p className="ct-feedback ct-feedback--ok">
                ¡Mensaje enviado! Te respondemos pronto.
              </p>
            )}
            {status === 'error' && (
              <p className="ct-feedback ct-feedback--err">
                Error al enviar: {errorDetail || 'Intentá de nuevo o escribinos directamente a branchdevelopment.ar@gmail.com'}
              </p>
            )}
            {status === 'config-error' && (
              <p className="ct-feedback ct-feedback--err">
                El servicio de envío no está configurado todavía. Contactanos por email directamente.
              </p>
            )}
          </form>
        </div>

        <div className="ct-hero-illustration">
          <IllustrationContact />
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Contacto;
